import script from "./rolesCommons.vue?vue&type=script&lang=js"
export * from "./rolesCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__